import { useTimezone } from '@mews/framework';
import { getCustomer } from '@mews-commander/legacy-entities/src/ducks';
import { getCurrentEnterpriseReservation } from '@mews-commander/legacy-entities/src/selectors/reservations';
import { useCommanderSelector } from '@mews-commander/utils';
import { isBirthdayBetweenDates } from '../utils/isBirthdayBetweenDates';

export const useCustomerHasBirthdayDuringReservation = (customerId: string, reservationId: string): boolean => {
    const customer = useCommanderSelector((state) => getCustomer(state, { id: customerId }));
    const reservation = useCommanderSelector((state) => getCurrentEnterpriseReservation(state, { id: reservationId }));
    const timezone = useTimezone();

    if (!customer?.birthDate || !reservation) {
        return false;
    }

    return isBirthdayBetweenDates({
        birthDate: customer.birthDate,
        startDate: reservation.startUtc,
        endDate: reservation.endUtc,
        timezone,
    });
};
